export const CARE_CONTENT = {
  breadcrumb: 'Care Guide',
  bestFor: 'Best for',
  title: 'How to care for your plush friends',
  subtitle:
    'Keep your cuddly companions clean, soft, and huggable for years to come with our expert care guide.',
  methods: [
    {
      icon: 'Droplets',
      title: 'Machine Wash',
      desc: 'Gentle cycle, cold water (30°C)',
      steps: [
        'Place in a mesh laundry bag',
        'Use mild detergent, no bleach',
        'Gentle cycle with cold water',
        'Air dry or low heat tumble dry',
      ],
      suitable: 'Most plush toys with removable accessories',
      color: 'bg-blue-50 text-blue-500',
      border: 'border-blue-100',
    },
    {
      icon: 'Sun',
      title: 'Hand Wash',
      desc: 'For delicate or large toys',
      steps: [
        'Fill sink with lukewarm water',
        'Add mild detergent and mix',
        "Gently squeeze, don't wring",
        'Rinse thoroughly and pat dry',
      ],
      suitable: 'Delicate fabrics, large toys, items with electronics',
      color: 'bg-secondary-50 text-secondary-500',
      border: 'border-secondary-100',
    },
    {
      icon: 'Wind',
      title: 'Surface Clean',
      desc: 'Quick spot cleaning',
      steps: [
        'Mix mild soap with water',
        'Use a soft cloth or sponge',
        'Gently blot the stained area',
        'Let air dry completely',
      ],
      suitable: 'Small stains, toys with sound boxes, delicate items',
      color: 'bg-purple-50 text-purple-500',
      border: 'border-purple-100',
    },
  ],
  dosAndDonts: {
    dos: {
      title: "The Do's",
      items: [
        'Use mild, dye-free detergent',
        'Check care label first',
        'Remove any electronic components',
        'Air dry when possible',
        'Fluff while damp to reshape',
      ],
    },
    donts: {
      title: "The Don'ts",
      items: [
        'Never use hot water (shrinks fabric)',
        'Avoid bleach or harsh chemicals',
        "Don't wring or twist aggressively",
        'Never iron plush toys',
        "Don't dry clean (chemicals harmful)",
      ],
    },
  },
  maintenance: {
    title: 'Maintenance Tips',
    tips: [
      {
        icon: 'Sun',
        title: 'Sun Protection',
        description:
          'Keep your plushies away from direct sunlight for long periods to prevent fading and maintain fabric strength.',
      },
      {
        icon: 'Wind',
        title: 'Air It Out',
        description:
          'Give your cuddly friends a fresh breath of air occasionally. A light shake or gentle vacuuming keeps them dust-free.',
      },
    ],
  },
} as const;
